module.exports = __webpack_public_path__ + "img/111.3b0f2d31.jpg";